import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';

import { ICard } from '../types';

const createDriverBlockedCard = (
  {
    contactOperationTeam,
  }: {
    contactOperationTeam: string;
  },
  intl: IntlShape,
): ICard => ({
  id: 'blocked_driver',
  cardStatus: 'rejected',
  desc: (
    <FormattedMessage
      defaultMessage="Please get in touch with <a>customer service</a> ({link})"
      id="brDWLJ"
      description="Page description"
      values={{
        a: (text: React.ReactNode) => (
          <a href={`mailto:${contactOperationTeam}`} target="_blank" rel="noreferrer">
            {text}
          </a>
        ),
        link: contactOperationTeam,
      }}
    />
  ),
  isExcludedFromProgress: true,
  order: -10,
  title: intl.formatMessage({
    defaultMessage: 'Your account has been blocked',
    id: 'TDrhF6',
    description: 'Page title',
  }),
});

export { createDriverBlockedCard };
